import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import './FormElement.scss'
import { IconQuestion } from '../SVGIcons/IconQuestion'

const FORM_ELEMENT_FEEDBACK_DANGER = 'danger'

export const FORM_ELEMENT_SPACING_DEFAULT = 'default'
export const FORM_ELEMENT_SPACING_SMALL = 'small'

export const FormElement = ({
  children,
  className,
  feedback,
  feedbackVariant,
  hint,
  label,
  labelFor,
  required,
  'data-mu-test': dataAttributeTest,
  LabelRightComponent,
  labelHelp,
  labelSpacing
}) => {
  return (
    <div
      className={classnames('c-form-element', className, {
        'c-form-element--required': required
      })}
      data-mu-test={classnames('form-element', dataAttributeTest)}
    >
      {label && (
        <div
          className={classnames('c-form-element__label-container', {
            'c-form-element__label-container--small':
              labelSpacing === FORM_ELEMENT_SPACING_SMALL
          })}
        >
          <div className='c-form-element__left-label'>
            <label htmlFor={labelFor} className='c-form-element__label'>
              {label}
            </label>
            {labelHelp && (
              <IconQuestion
                data-tip={labelHelp}
                className='c-form-element__tooltip'
              />
            )}
          </div>
          {LabelRightComponent && <LabelRightComponent />}
        </div>
      )}
      <div className='c-form-element__field'>{children}</div>
      {feedback && (
        <p
          className={classnames('c-form-element__feedback', {
            'c-form-element__feedback--danger':
              feedbackVariant === FORM_ELEMENT_FEEDBACK_DANGER
          })}
          data-mu-test={classnames('form-element__feedback', {
            [`${dataAttributeTest}__feedback`]: dataAttributeTest
          })}
        >
          {feedback}
        </p>
      )}
      {hint && (
        <p
          className='c-form-element__hint'
          data-mu-test={classnames('form-element__hint', {
            [`${dataAttributeTest}__hint`]: dataAttributeTest
          })}
        >
          {hint}
        </p>
      )}
    </div>
  )
}

FormElement.defaultProps = {
  feedbackVariant: FORM_ELEMENT_FEEDBACK_DANGER,
  labelSpacing: FORM_ELEMENT_SPACING_DEFAULT
}

FormElement.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  feedback: PropTypes.string,
  feedbackVariant: PropTypes.oneOf([FORM_ELEMENT_FEEDBACK_DANGER]),
  hint: PropTypes.string,
  label: PropTypes.string,
  labelFor: PropTypes.string,
  required: PropTypes.bool,
  /**
   * Additional values for data-attribute used for tests and tracking
   **/
  'data-mu-test': PropTypes.string,
  LabelRightComponent: PropTypes.node,
  labelHelp: PropTypes.string,
  labelSpacing: PropTypes.oneOf([
    FORM_ELEMENT_SPACING_DEFAULT,
    FORM_ELEMENT_SPACING_SMALL
  ])
}
